module.exports = __webpack_public_path__ + "media/images/landing/second/photo3-5a4cdd3d6dff537ddd409d68bb86472f.jpg";